<template>
    <div v-if="element && element.style && element.style.customCss" v-html="'<style>' + element.style.customCss + '</style>'"></div>
    <div class="sk-element-wrapper" :class="element.id + '-wrapper'" v-if="element.props" @dblclick.stop="onClick()">
        <template v-if="element.props.value && element.props.value !== '' && element.props.value !== 'null'">
            <div :style="styleObject" :class="element.props.class" v-html="element.props.value"></div>
        </template>
        <template v-else>
            <div class="sk-not-selected-element">Add Text Content</div>
        </template>
    </div>
</template>

<script>
export default {
    name: "Textblock",
    props: {
        element: {
            required: true,
            type: Object,
        },
    },
    methods: {
        onClick() {
            this.$emit("onClick", this.element);
        },
    },
    computed: {
        styleObject() {
            return {
                padding: this.element.style.padding,
                margin: this.element.style.margin,
                borderRadius: this.element.style.borderRadius,
            };
        },
    },
    emits: ["onClick"],
};
</script>
